// en, ar
export default {
  en: {
    app_name: "Arzaq Masr",
    //   NavMenu
    dashboard: "Dashboard",
    managementStation: "Stations",
    managementCoop: "Coops",
    managementCourse: "Periods",
    managementEmployee: "Employees",
    consultants: "Doctors",
    accounts: "Accounting",
    reports: "Financial Reports",
    compareCourses: "Compare Periods",
    // Home
    generalStatistics: "General statistics",
    lang: "AR",
    stationStatistics: "Station statistics",
    population_ratio: "Population ratio",
    daily_dead: "Daily dead ratio",
    total_dead: "Total dead",
    period_stations: "Station Periods",
    coop: "Coop",
    day: "Day",
    average_weight: "Average weight",
    station: "Station",
    stations: "Stations",
    active_periods: "Active periods",
    finished_periods: "Finished periods",
    tickets: "Tickets",

    //Employees
    profile_image: "Profile image",
    accepted_image_types:
      "Only *.png, *.jpg and *.jpeg image files are accepted",
    employees_list: "Employees list",
    search: "Search",
    add_employee: "Add employee",
    employee_information: "Employee information",
    edit: "Edit",
    delete: "Delete",
    email: "Email",
    phone_number: "Phone number",
    station_information: "Station information",
    winter_density: "Winter density",
    chicken: "Chicken",
    summer_density: "Summer density",
    new_doctor_request: "New doctor request",
    there_are_no_doctors: "There are no doctors",
    doctors_list: "Doctors list",
    current_doctors: "Current doctors",
    m: "M",
    summer: "Summer",
    winter: "Winter",
    doctor_information: "Doctor information",
    supervision_price: "Supervision price",
    supervision_request: "Supervision request",
    rates: "Rates",
    governorates: "Governorates",
    coops: "Coops",
    bio: "Bio",
    total_purchases: "Total purchases",
    purchases_record: "Purchases record",
    from: "From",
    to: "To",
    type: "Type",
    not_found: "not found",
    password: "Password",
    confirmation_password: "Confirmation password",
    please_wait: "Please wait",
    worker: "Worker",
    engineer: "Engineer",
    employee_created_successfully: "Employee has been created successfully",
    employee_updated_successfully: "Employee is deleted successfully",
    employee_delete_successfully: "Employee is deleted successfully",
    there_are_no_employees: "There are no Employees",
    area: "Area",

    //Accounting
    purchases: "Purchases",
    sales: "Sales",
    expenses: "Expenses",
    add_chicks: "Add chicks",
    add_purchases: "Add purchases",
    process_name: "Process name",
    product: "Product",
    start_quantity: "Start quantity",
    quantity: "Quantity",
    unit_price: "Unit price",
    total: "Total",
    date: "Date",
    action: "Action",
    period: "Period",
    weight: "Weight",
    note: "Note",
    total_sales: "Total sales",
    sales_record: "Sales record",
    add_sales: "Add sales",
    name: "Name",
    employee: "Employee",
    price: "Price",
    total_expenses: "Total expenses",
    add_expenses: "Add expenses",
    expenses_record: "Expenses record",
    expense_name: "Expense name",
    cost: "Cost",
    save_edits: "Save edits",
    add: "Add",
    edit_sales: "Edit sales",
    kilo_price: "Kilo price",
    edit_expenses: "Edit expenses",

    //Compare
    period_start_date: "Period start date",
    period_days_count: "Period days count",
    vital_ratio: "Vital ratio",
    meat_quantity: "Meat quantity",
    revenue: "Revenue",
    food_consumption: "Food consumption",
    used_water_quantity: "Used water quantity",
    compare_periods: "Compare period",
    select_period: "Select period",

    //Station
    a_coop: "Coop",
    get_directions: "Get directions",
    deleting: "Deleting",
    precautionary_safety_measures: "Precautionary safety measures",
    farming_system: "Farming system",
    has_fence: "Has fence",
    has_guestbook: "Has guestbook",
    has_guest_uniform: "Has guest uniform",
    has_motor_purge: "Has motor purge",
    has_guest_bathroom: "Has guest bathroom",
    has_garage: "Has garage",
    station_employees: "Station employees",
    governorate: "Governorate",
    city: "City",
    address: "Address",
    ground: "Ground",
    open: "Open",
    batteries: "Batteries",
    closed: "Closed",
    save: "Save",
    saving: "Saving",
    stations_list: "Stations list",
    add_station: "Add station",
    station_has_been_created_successfully:
      "Station has been created successfully",
    station_delete_successfully: "Station is deleted successfully",
    station_has_been_updated_successfully:
      "Station has been updated successfully",
    are_you_sure_about_deleting_this_item:
      "Are you sure about deleting this item ?",
    yes: "Yes",
    no: "No",
    there_is_no_stations: "There's no stations",
    enter_your_location: "Enter your location",
    no_item_is_selected: "No item is selected",
    there_is_no_coops: "There is no coops",
    add_coop: "Add coop",
    there_is_no_employees: "There is no employees",

    purchase_delete_successfully: "Purchase is deleted successfully",
    purchase_created_successfully: "Purchase has been created successfully",
    purchase_updated_successfully: "Purchase is updated successfully",
    all_stations: "All stations",

    //coops
    coop_information: "Coop information",
    chicks_density: "Chicks density",
    floor_covering_system: "Floor covering system",
    plastic: "Plastic",
    sawdust: "Sawdust",
    feeding_system: "Feeding system",
    plates: "Plates",
    feeder: "Feeder",
    manual_feeding: "Manual feeding",
    drinking_system: "Drinking system",
    river: "River",
    automatic: "Automatic",
    manual: "Manual",
    heating_system: "Heating system",
    heater: "Heater",
    kerosene_heater: "Kerosene heater",
    gas_heater: "Gas heater",
    ventilation_system: "Ventilation system",
    cooling_cells: "Cooling cells",
    windows: "Windows",
    winch_curtains: "Winch curtains",
    ventilation_fans: "Ventilation fans",
    ventilation_fan: "Ventilation fan",
    size: "Size",
    coop_name: "Coop name",
    summer_chicks_density: "Summer chicks density",
    winter_chicks_density: "Winter chicks density",
    height: "height",
    width: "width",
    coops_list: "Coops list",
    busy: "Busy",
    empty: "Empty",
    coop_deleted_successfully: "Coop is deleted successfully",
    coop_has_been_created_successfully: "Coop has been created successfully",
    coop_has_been_updated_successfully: "Coop has been updated successfully",
    enable_notification_message:
      "Enable notification to keep track with your stations",
    enable: "Enable",
    hide: "Hide",

    periods_list: "Periods list",
    add_period: "Add period",
    there_is_no_periods: "There is no periods",
    period_information: "Period information",
    daily_chores: "Daily chores",
    daily_instruction: "Daily instruction",
    period_tickets: "Period tickets",
    period_treatment_plans: "Treatment plans",
    period_report: "Period report",
    start_period: "Start period",
    starting_period: "Starting period",
    period_delete_successfully: "Period is deleted successfully",
    period_name: "Period name",
    add_disinfection_program_to_period: "Add disinfection program to period",
    delete_disinfection_program_to_period:
      "Delete disinfection program to period",
    disinfection_program: "Disinfection program",
    medicines: "Medicines",
    medicine_instruction: "Medicine instruction",
    write_here_the_medicine_instructions_in_the_disinfection_process:
      "Write here the medicine instructions in the disinfection process",
    period_has_been_created_successfully:
      "Period has been created successfully",
    period_has_been_updated_successfully:
      "Period has been updated successfully",
    current_normal_average_weight: "Current/normal average weight",
    gram: "gram",
    required_water: "Required water",
    ventilation_required_am: "Required ventilation (am)",
    ventilation_required_pm: "Required ventilation (pm)",
    required_lighting: "Required lighting",
    liter: "Liter",
    watt: "Watt",
    cure: "Cure",
    immunization: "Immunization",
    add_treatment_plan: "Add treatment plan",
    there_is_no_treatment_plans: "There's no treatment plans",
    plan_type: "Plan type",
    plan_name: "Plan name",
    diseases: "Diseases",
    medicine_details: "Medicine details",
    medicine_instructions: "Medicine instructions",
    days: "Days",
    add_another_medicine: "Add another medicine",
    finished_at: "Finished at",
    started_at: "Started at",
    not_started: "Not started",
    add_by: "Add by",
    medicine_name: "Medicine name",
    medicine: "Medicine",
    cumulative_period_report: "Cumulative period report",

    period_started_at: "Period started at",
    chicks_count: "Chicks count",
    vitality_ratio: "Vitality ratio",
    dead_ratio: "Dead ratio",
    water_used_quantity: "Water used quantity",
    current_day: "Current day",
    feeding: "Feeding",
    food: "Food",
    food_count: "Food count",
    dead: "Dead",
    morning_dead: "Morning dead",
    evening_dead: "Evening dead",
    temperature: "Temperature",
    humidity: "Humidity",
    KG: "KG",
    av_weight: "av.weight",
    select_food: "Select food",
    daily_chore_is_store_successfully: "Daily chore is stored successfully",
    request_has_been_sent: "Request has been sent",
    request_to_supervise_station: "Request to supervise a station",
    doctor: "Doctor",
    supervisor_of_the_station: "Supervisor of the station",
    rejected: "Rejected",
    request_sent: "Request sent",
    select_station: "Select station",
    cancel: "Cancel",
    approve_request: "Approve request",
    there_is_no_busy_coops: "There is no busy coops",
    there_is_not_open_tickets: "There is no open tickets",
    treatment_added_successfully: "Treatment plan is created successfully",
    daily_food_consumption: "Daily food consumption",
    owner: "Owner",
    finish_period: "Finish period",
    finishing_period: "Finishing period",
    period_is_finished: "Period is finished successfully",
    detailed_report: "Detailed report",
    no_daily_chore: "There is no daily chore",
    no_data: "No data",
    page_not_found: "Page not found",
    there_is_no_tickets: "There's no tickets",
    open_new_ticket: "Open new ticket",
    ticket_details: "Ticket details",
    add_ticket: "Add ticket",
    subject: "Subject",
    description: "Description",
    images: "Images",
    audio: "Audio",
    start_record: "Start record",
    ticket_added_successfully: "Ticket is added successfully",
    please_attach_maximum_of_5_photos_to_describe_your_complaint:
      "Please attach a maximum of 5 photos to describe your ticket",
    edit_purchase: "Edit purchases",
    add_chick_purchase: "Add purchases as chicks",
    organization: "Organization",
    family: "Family",
    chick_name: "Chick name",
    purchases_type: "Purchases type",
    medicine_category: "Medicine category",
    medicine_type: "Medicine type",
    active_ingredient: "Active ingredient",
    food_name: "Food name",
    item_delete_successfully: "Item is deleted successfully",
    item_has_updated_successfully: "Item has been updated successfully",
    item_has_added_successfully: "item has been added successfully",
    edit_purchases: "Edit purchases",
    statistics: "Statistics",
    upload_image: "Upload image",
    stop_record: "Stop record",
    ticket_delete_successfully: "Ticket is deleted successfully",
    technical_management: "Technical management",
    notification: "Notification",
    there_is_no_notifications: "There is no notifications",
    gain: "Gain",
    loss: "Loss",
  },

  ar: {
    app_name: "ارزاق مصر",
    //   NavMenu
    dashboard: "لوحة التحكم",
    managementStation: "إدارة المحطات",
    managementCoop: "إدارة العنابر",
    managementCourse: "إدارة الدورات",
    managementEmployee: "إدارة العاملين",
    consultants: "الإستشاريين",
    accounts: "الحسابات",
    reports: "التقارير",
    compareCourses: "مقارن الدورات",
    // Home
    generalStatistics: "إحصائيات عامة",
    lang: "EN",
    stationStatistics: "إحصائيات المحطات",
    population_ratio: "نسيه التسكين",
    daily_dead: "النافق اليومي",
    total_dead: "النافق الكلي",
    period_stations: "دورات المحطات",
    coop: "العنبر",
    day: "اليوم",
    average_weight: "متوسط الوزن",
    station: "المحطة",
    stations: "المحطات",
    active_periods: "دورات نشطة",
    finished_periods: "الدورات المنتهيه",
    tickets: "الشكاوى",

    //Employees
    profile_image: "صورة الملف الشخصي",
    accepted_image_types: "تقبل فقط ملفات الصور * .png و * .jpg و * .jpeg",
    employees_list: "قائمة العمال",
    search: "بحث",
    add_employee: "إضافة عامل جديد",
    employee_information: "معلومات العامل",
    edit: "تعديل",
    delete: "حذف",
    email: "البريد",
    phone_number: "رقم الهاتف",
    station_information: "معلومات المحطة",
    winter_density: "كثافة الشتاء",
    chicken: "دجاجة",
    summer_density: "كثافة الصيف",
    new_doctor_request: "طلب إستشاري جديد",
    there_are_no_doctors: "لا يوجد إستشاريين",
    doctors_list: "قائمة الاستشاريين",
    current_doctors: "الإستشاريين الحاليين",
    m: "م",
    summer: "صيف",
    winter: "شتاء",
    supervision_price: "سعر الاشراف",
    supervision_request: "طلب الاشراف",
    rates: "التقييمات",
    governorates: "المحافظات",
    bio: "نبذة",
    doctor_information: "معلومات الاستشاري",
    coops: "العنابر",
    not_found: "لا يوجد",
    password: "كلمه المرور",
    confirmation_password: "تأكيد كلمه المرور",
    please_wait: "برجاء الانتظار",
    worker: "عامل",
    engineer: "مهندس",
    employee_created_successfully: "تم إضافة الموظف بنجاح",
    employee_updated_successfully: "تم تعديل الموظف بنجاح",
    employee_delete_successfully: "تم حذف الموظف بنجاح",
    there_are_no_employees: "لا يوجد عمال",
    area: "المساحة",

    //Accounting
    total_purchases: "إجمالي المشتريات",
    purchases_record: "سجل المشتريات",
    from: "من",
    to: "الى",
    type: "النوع",
    purchases: "المشتريات",
    sales: "المبيعات",
    expenses: "المصروفات",
    add_chicks: "إضافة كتاكيت",
    add_purchases: "إضافة مشتريات",
    process_name: "اسم العملية",
    product: "المنتج",
    start_quantity: "الكميه الابتدائيه",
    quantity: "الكميه",
    unit_price: "السعر الوحده",
    total: "السعر الكلي",
    date: "التاريخ",
    action: "إجراء",
    period: "الدورة",
    weight: "الوزن",
    note: "الملاحظات",
    total_sales: "إجمالي المبيعات",
    sales_record: "سجل المبيعات",
    add_sales: "إضافة مبيعات",
    name: "الاسم",
    employee: "الموظف",
    price: "السعر",
    total_expenses: "إجمالي المصروفات",
    add_expenses: "إضافة مضروفات",
    expenses_record: "سجل المصروفات",
    expense_name: "اسم المصروف",
    cost: "التكلفة",
    save_edits: "حفظ التعديلات",
    add: "إضافة",
    edit_sales: "تعديل المبيعات",
    kilo_price: "سعر الكليو",
    edit_expenses: "تعديل المصروفات",

    //compare
    period_start_date: "تاريخ بداية الدورة",
    period_days_count: "عدد أيام الدورة",
    vital_ratio: "نسبة الحيوية",
    meat_quantity: "كمية اللحم المنتجة",
    revenue: "الأرباح",
    food_consumption: "استهلاك العلف",
    used_water_quantity: "كمية المياة المستخدمة",
    compare_periods: "مقارنة الدورات",
    select_period: "إختر دورة",

    //station
    a_coop: "عنبر",
    get_directions: "احصل علي الاتجاهات",
    deleting: "جاري الحذف",
    precautionary_safety_measures: "إجراءات الأمان الاحترازي",
    farming_system: "نظام التربية",
    has_fence: "يوجد سور للمحطة",
    has_guestbook: "يوجد سجل الزوار",
    has_garage: "يوجد مغطس سيارات",
    has_guest_uniform: "يوجد زي خاص للزوار",
    has_motor_purge: "يوجد موتور تطهير",
    has_guest_bathroom: "يوجد دورات مياة للزوار",
    station_employees: "العاملين بالمحظة",
    governorate: "المحافظة",
    city: "المدينة",
    address: "العنوان",
    ground: "أرضي",
    open: "مفتوح",
    batteries: "بطاريات",
    closed: "مغلق",
    save: "حفظ",
    saving: "جاري الحفظ",
    stations_list: "قائمة المحطات",
    add_station: "إضافة محطة جديدة",
    station_has_been_created_successfully: "تم إضافة المحطة بنجاح",
    station_delete_successfully: "تم حذف المحظة بنجاح",
    station_has_been_updated_successfully: "تم تحديث المحطه بنجاح",
    are_you_sure_about_deleting_this_item: "هل أنت متأكد من حذف هذا العنصر",
    yes: "نعم",
    no: "لا",
    there_is_no_stations: "لا توجد محطات",
    enter_your_location: "أدخل موقعك",
    no_item_is_selected: "لم يتم اختيار عنصر",
    there_is_no_coops: "ﻻ يوجد عنابر",
    add_coop: "إضافة عنبر جديد",
    there_is_no_employees: "ﻻ يوجد عاملين",

    purchase_delete_successfully: "تم حذف المشتريات بنجاح",
    purchase_created_successfully: "تم إضافة المشتريات بنجاح",
    purchase_updated_successfully: "تم تعديل المشتريات بنجاح",
    all_stations: "كل المحطات",

    //coops
    coop_information: "معلومات العنبر",
    chicks_density: "كثافة الطيور",
    floor_covering_system: "نظام الفرشة",
    plastic: "بلاستيك",
    sawdust: "نشارة",
    feeding_system: "نظام العلف",
    plates: "أطباق تحصين",
    feeder: "فيدر",
    manual_feeding: "علف يدوي",
    drinking_system: "نظام الشرب",
    river: "نيل",
    automatic: "سقايات اتوماتيك",
    manual: "سقايات يدوي",
    heating_system: "نظام التدفئة",
    heater: "هيتر",
    kerosene_heater: "دفايات كيروسين",
    gas_heater: "دفايات غاز",
    ventilation_system: "نظام التهوية",
    cooling_cells: "خلايا تبريد",
    windows: "شبابيك",
    winch_curtains: "ستائر ونش",
    ventilation_fans: "الشفاطات",
    ventilation_fan: "شفاط",
    size: "الحجم",
    coop_name: "اسم العنبر",
    summer_chicks_density: "كثافة الطيور صيفا",
    winter_chicks_density: "كثافة الطيور شتاءا",
    height: "الطول",
    width: "العرض",
    coops_list: "قائمة العنابر",
    busy: "مشغول",
    empty: "فارغ",
    coop_deleted_successfully: "تم حذف العنبر بنجاح",
    coop_has_been_created_successfully: "تم إضافة العنبر بنجاح",
    coop_has_been_updated_successfully: "تم تحديث العنبر بنجاح",
    enable_notification_message:
      "قم بالسماح بقبول الاشعارات والتنويهات لتتمكن من متابعة محطاتك",
    enable: "تفعيل",
    hide: "إخفاء",

    periods_list: "قائمة الدورات",
    add_period: "إضافة دورة جديدة",
    there_is_no_periods: "لا يوجد دورات",
    period_information: "معلومات الدورة",
    daily_chores: "الأعمال اليومية",
    daily_instruction: "الإرشادات اليومية",
    period_tickets: "تذاكر الدورة",
    period_treatment_plans: "برامج الدورة",
    period_report: "تقارير الدورة",
    start_period: "بدء الدورة",
    starting_period: "جاري بدء الدورة",
    period_delete_successfully: "تم حذف الدورة بنجاح",
    period_name: "اسم الدورة",
    add_disinfection_program_to_period: "إضافة برنامج تطهير الدورة",
    delete_disinfection_program_to_period: "حذف برنامج تطهير الدورة",
    disinfection_program: "برنامج التطهير",
    medicines: "أدوية",
    medicine_instruction: "إرشادات الدواء",
    write_here_the_medicine_instructions_in_the_disinfection_process:
      "تكتب هنا إرشادات إستخدام الدواء في عملية التطهير",

    period_has_been_created_successfully: "تم إضافة الدورة بنجاح",
    period_has_been_updated_successfully: "تم تحديث الدورة بنجاح",
    current_normal_average_weight: "متوسط الوزن الحالي / الطبيعي",
    gram: "جرام",
    required_water: "المياة المطلوبة",
    ventilation_required_am: "التهوية المطلوبة (صباحا)",
    ventilation_required_pm: "التهوية المطلوبة (ليلا)",
    required_lighting: "الإضاءة المطلوبة",
    liter: "لتر",
    watt: "وات",
    cure: "العلاج",
    immunization: "التحصين",
    add_treatment_plan: "إنشاء برنامج جديد",
    there_is_no_treatment_plans: "لا يوجد برامج علاجية",
    plan_type: "نوع البرنامج",
    plan_name: "إسم البرنامج",
    diseases: "الأمراض",
    medicine_details: "تفاصيل الدواء",
    medicine_instructions: "إرشادات الدواء",
    days: "الأيام",
    add_another_medicine: "إضافة دواء أخر",
    finished_at: "انتهت في",
    started_at: "بدءت في",
    not_started: "لم تبدأ",
    add_by: "تمت الإضافة بواسطة",
    medicine_name: "اسم الدواء",
    medicine: "الدواء",
    cumulative_period_report: "تقرير الدورة التراكمي",
    period_started_at: "تاريخ بداية الدورة",
    chicks_count: "عدد الطيور",
    vitality_ratio: "معدل الحيوية",
    dead_ratio: "معدل النافق",
    water_used_quantity: "استهلاك كمية المياه",
    current_day: "اليوم الحالي",
    feeding: "التغذية",
    food: "العلف",
    food_count: "عدد الشكاير",
    dead: "النافق",
    morning_dead: "النافق صباحا",
    evening_dead: "النافق مساءا",
    temperature: "درجة الحرارة",
    humidity: "الرطوبة",
    KG: "كجم",
    av_weight: "م.الوزن",
    select_food: "إختر علف",
    daily_chore_is_store_successfully: "تم تخزين الاعمال اليومية بنجاح",
    request_has_been_sent: "تم إرسال الطلب",
    request_to_supervise_station: "طلب إشراف علي محطة",
    doctor: "إستشاري",
    supervisor_of_the_station: "مشرف علي المحطه",
    rejected: "تم الرفض",
    request_sent: "تم ارسال طلب",
    select_station: "تحديد المحطه",
    cancel: "إلغاء",
    approve_request: "تأكيد الطلب",
    there_is_no_busy_coops: "لا يوجد عنابر مشغولة",
    there_is_not_open_tickets: "لا يوجد شكاوى مفتوحة",
    treatment_added_successfully: "تم إضافة برنامج علاجي بنجاح",
    daily_food_consumption: 'كميلة العلف المستهلك "يومي"',
    owner: "المالك",
    finish_period: "ترحيل الدورة",
    finishing_period: "جاري ترحيل الدورة",
    period_is_finished: "انتهت الدورة بنجاح",
    detailed_report: "تقرير تفصيلي",
    no_daily_chore: "ﻻ توجد اعمال روتينية",
    no_data: "لا يوجد بيانات",
    page_not_found: "هذة الصفحة غير موجودة",
    there_is_no_tickets: "لا يوجد تذاكر",
    open_new_ticket: "فتح تذكرة جديدة",
    ticket_details: "تفاصيل التذكرة",
    add_ticket: "إضافة تذكرة",
    subject: "الموضع",
    description: "الوصف",
    images: "الصور",
    audio: "التسجيل الصوتي",
    start_record: "بدء التسجيل",
    ticket_added_successfully: "تم إضافة التذكرة بنجاح",
    please_attach_maximum_of_5_photos_to_describe_your_complaint:
      "برجاء إرفاق 5 صور لحد اقصى لوصف الشكوي",
    edit_purchase: "تعديل مشتريات",
    add_chick_purchase: "إضافة مشتريات كتاكيت",
    organization: "الشركة",
    family: "الفصيله",
    chick_name: "اسم الكتكوت",
    purchases_type: "نوع المشتريات",
    medicine_category: "قسم الدواء",
    medicine_type: "نوع الدواء",
    active_ingredient: "المادة الفعالة",
    food_name: "اسم العلف",
    item_delete_successfully: " تم حذف العنصر بنجاح",
    item_has_updated_successfully: "تم تعديل العنصر بنجاح",
    item_has_added_successfully: "تم اضافة العنصر بنجاح",
    edit_purchases: "تعديل المشتريات",
    upload_image: "رفع صورة",
    stop_record: "توقف التسجيل",
    ticket_delete_successfully: "تم حذف التذكرة بنجاح",
    technical_management: "الإدارة الفنية",
    notification: "إشعارات",
    there_is_no_notifications: "لا يوجد إشغارات",
    gain: "مكسب",
    loss: "خسارة",
  },
};
